import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateModule, TranslateService } from '@ngx-translate/core'; // Import TranslateService

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  imports: [TranslateModule, MatIconModule],
  styleUrl: './file-upload.component.scss',
})
export class FileUploadComponent implements OnDestroy {
  @Input() allowedFileTypes: string[] = []; // Internally allowed file types
  @Input() selectableFileTypes = ''; // File picker filter
  @Input() inputLabel: string | undefined;
  @Output() fileUploaded = new EventEmitter<File>(); // Emit uploaded file
  protected readonly document = document;
  @Input() disabled: boolean = false;

  constructor(
    private readonly snackBar: MatSnackBar,
    private translate: TranslateService, // Inject TranslateService
  ) {}

  // Snackbar styled globally

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input?.files?.length) {
      const file = input.files[0];
      const fileType = file.type;

      if (
        this.isValidFileType(fileType) ||
        this.isValidFileExtension(file.name)
      ) {
        this.fileUploaded.emit(file);
      } else {
        this.notifyError(
          this.translate.instant('file.upload.error.invalid_type'),
        );
      }
    }
  }

  private isValidFileExtension(fileName: string) {
    const extension = fileName.split('.').pop()?.toLowerCase();
    if (extension) {
      return this.selectableFileTypes.includes(extension);
    } else return false;
  }

  private isValidFileType(fileType: string): boolean {
    return this.allowedFileTypes.includes(fileType);
  }

  notifySuccess(): void {
    this.snackBar.open(
      this.translate.instant('file.upload.success'),
      this.translate.instant('file.upload.close'),
      {
        duration: 3000,
        panelClass: ['success-snackbar'],
      },
    );
  }

  notifyError(message: string): void {
    this.snackBar.open(message, this.translate.instant('file.upload.close'), {
      duration: 5000,
      panelClass: ['error-snackbar'],
    });
  }

  ngOnDestroy() {
    this.snackBar.dismiss();
  }
}
